import Stack from '@mui/material/Stack';
import emptyImg from '@assets/empty.png';
import propTypes from 'prop-types';
import classes from './Empty.module.css';

function Empty({ primary, secondary, hidden }) {
  return (
    <Stack
      sx={{
        marginTop: '30px',
        height: '280px',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'space-between',
      }}
      hidden={hidden}
    >
      <img src={emptyImg} className={classes.empty_img} alt="" />
      {primary ? <div className={classes.empty_text}>{primary}</div> : null}
      {secondary ? <div className={classes.empty_tips}>{secondary}</div> : null}
    </Stack>
  );
}

Empty.propTypes = {
  primary: propTypes.string.isRequired,
  secondary: propTypes.string.isRequired,
  hidden: propTypes.bool,
};

export default Empty;
